import { api } from '@stageplottter/core';
import { getApi } from '../../api/endpoints';

export type Inventory = api.Inventory;

/** Own inventory of a workspace (decision U15). */
export function inventoryApi() {
  const client = getApi().client;
  const url = (ws: string) => `/workspaces/${encodeURIComponent(ws)}/inventory`;
  return {
    get: (ws: string) => client.get(url(ws), api.Inventory),
    put: (ws: string, body: api.PutInventory) => client.put(url(ws), body, api.Inventory),
  };
}
